// ============================================================================
// prova.jsx — ÇELËSI I VETËM I PROVËS NDARËSE
//
//   ⚠ I PËRKOHSHËM, gusht 2026. Kthehet te `PROVA = 0` dhe skedari fshihet
//     bashkë me `diagnoza.js` para se aplikacioni t'u shkojë familjeve.
//
// ---------------------------------------------------------------------------
// PSE EKZISTON
//
// Aplikacioni rrëzohej vetëm brenda WKWebView-it të iOS-it, pa asnjë gabim
// JavaScript. Katër hamendje me radhë nuk e gjetën. Prandaj ndaluam së
// hamendësuari dhe e ndajmë problemin në gjysma, një provë për çdo pyetje.
//
// PROVA 1 — vetëm një numërues, asgjë tjetër e jona. Numri kaloi 90.
// → Guaska (Capacitor, shtojcat, WKWebView) është e shëndoshë.
//
// PROVA 2 — `App` i plotë, por pas hyrjes vizatohej vetëm numëruesi. Kaloi 170.
// → Efektet dhe të dhënat janë të pastra. Fajtori është te pamja.
//
// PROVA 3 — të pesë ekranet fikur, mbeti korniza. Numri nuk lëvizi fare.
// → Fajtori është te korniza, jo te ekranet.
//
// PROVA 4 — u hoq edhe e poshtmja (tab-et, FAB-i, `SupportChat`). Sekondat
// prapë 0; rivizatimet 2, 4, 3 — pra vetëm dy-tri rivizatime dhe mbaroi.
// → Ky është fakti më i vlefshëm deri tani. React-i NUK po rrotullohet: po të
//   ishte cikël render→gjendje→render, rivizatimet do të ishin me mijëra. Ata
//   janë tre. Domethënë fija kryesore bllokohet nga një punë e vetme, e gjatë,
//   që nis pas rivizatimit të fundit dhe nuk lëshon më — dhe iOS-i e vret
//   procesin që s'përgjigjet. (Njëherë sekondat nuk qenë 0: ajo punë nis pak
//   pas nisjes, jo në çastin e parë.)
//
// ---------------------------------------------------------------------------
// KU KA MBETUR TË FSHEHURI
//
// Ajo që quajtëm "korniza" nuk ishte një gjë e vetme. Nën shiritin e sipërm
// rrinë edhe rreth 2.600 rreshta dritaresh, panelesh dhe mbivendosjesh —
// dritarja e personit, panelet e roleve, arkivi, Familjet, importi, poster-i,
// lightbox-i. Shumica presin një flamur të mbyllur. Por "shumica" s'është provë.
//
//   a) SHIRITI I SIPËRM, njoftimet dhe sidebar-i;
//   b) TË GJITHA DRITARET dhe mbivendosjet.
//
// PROVA 5 — të gjitha dritaret fikur. Sekondat arritën 60 dhe rivizatimet 113.
// → Shiriti i sipërm dhe sidebar-i janë të pastër. Fajtori është te njëra prej
//   atyre dritareve. (113 rivizatime në 60 sekonda janë rreth dy në sekondë —
//   të shpeshta, por të rregullta; nuk është cikël.)
//
// ---------------------------------------------------------------------------
// PROVA 6, DHE PËRGJIGJJA QË E MBYLLI KËRKIMIN
//
// PROVA 6 nuk fiku asgjë të re. Ajo vetëm pyeti: cila nga ato tridhjetë dritare
// është vërtet e hapur? Sepse një dritare e mbyllur nuk vizatohet fare —
// `{flamuri && (...)}` ndalon aty — pra fajtori s'mund të ishte veçse dritare e
// hapur.
//
// Përgjigjja: "tani: asnjë · u panë: asnjë". Asnjë e vetme.
//
// Kjo dukej si rrugë pa krye, dhe ishte e kundërta. Nëse asnjë dritare nuk u
// hap, atëherë fikja e tyre te PROVA 5 nuk hoqi asgjë nga ekrani — dhe prapë
// PROVA 4 u thye ndërsa PROVA 5 rroi. Domethënë brenda atij blloku kishte diçka
// që vizatohet PA KUSHT. Nga 2.646 rreshta, është një i vetëm:
//
//     <AppLock session={authSession} C={COLORS} F={FONTS} t={t} />
//
// Brava e aplikacionit. Rri e montuar gjithmonë pas hyrjes, pa asnjë flamur, dhe
// vendos vetë — duke pyetur serverin — nëse do të mbulojë ekranin. Nuk e pashë
// sepse e kërkoja te lista e flamujve, dhe ajo s'ka flamur.
//
// ---------------------------------------------------------------------------
// PROVA 7 — VETËM BRAVA. U VËRTETUA.
//
// Gjithçka mbeti e fikur; u kthye vetëm `<AppLock>`. Sekondat 0, rivizatimet
// 2–4, rrëzim çdo ~10 sekonda — pra saktësisht sjellja e PROVËS 4, e riprodhuar
// nga një komponent i vetëm. Fajtori u gjet.
//
// Asnjë fotografi nuk u duk para se të ngrijë, dhe kjo është hollësi me peshë:
// bravë-ekrani e mbulon pamjen me një shtresë të errët PARA se t'i vijë vepra e
// artit. Po të kishte hyrë ai në skenë, ekrani do të errësohej dhe numrat do të
// zhdukeshin. Ata mbetën të dukshëm. Domethënë brava me shumë gjasa nuk vizaton
// asgjë — dhe fajin e ka ajo që BËN, jo ajo që tregon.
//
// ---------------------------------------------------------------------------
// PROVA 8 — BRAVA PA VIZATUAR. ASNJË NDRYSHIM.
//
// Efektet punuan, vizatimi u ndal, dhe u thye njësoj. Pra faji NUK është te ajo
// që brava tregon. Është te ajo që bën.
//
// ---------------------------------------------------------------------------
// PROVA 9 — GJURMËT. DHE FUNDI I KËRKIMIT.
//
// Çdo hap i bravës u shkrua në ekran në çastin që ndodhi. Rreshti i fundit që
// arriti të dukej:
//
//     checkBiometry: nis
//
// Aty ndalet gjithçka. `fetchMode()` u kthye; `BiometricAuth.checkBiometry()`
// nuk u kthye kurrë. Rreth dhjetë sekonda më vonë iOS-i e vret aplikacionin —
// dhe dhjetë sekonda është pikërisht afati i tij për një aplikacion që nuk
// përgjigjet. Prandaj edhe "rrëzimi çdo ~10 sekonda" ishte gjithmonë i njëjti
// interval: nuk ishte rastësi, ishte një orë.
//
// Shkaku: `@aparajita/capacitor-biometric-auth` i serisë 9 është ndërtuar për
// Capacitor 7, ndërsa projekti ka kaluar te Capacitor 8. Ana native e plugin-it
// nuk i përgjigjej më urës. Seria 10 është ajo për Capacitor 8.
//
// Tri ndreqje dolën nga kjo, dhe secila qëndron më vete:
//   1. plugin-i u ngrit te ^10.0.0;
//   2. brava nuk e pyet më pajisjen kur serveri thotë se veçoria s'ekziston —
//      më parë e pyeste gjithmonë, pra bënte punë pa qëllim;
//   3. çdo thirrje drejt sistemit ka tani afat: një bravë që nuk përgjigjet
//      mbetet e mbyllur, nuk e rrëzon derën.
//
// ---------------------------------------------------------------------------
// PROVA 0 — APLIKACIONI I PLOTË
//
// Nuk ka më çfarë të ndahet. Gjithçka është kthyer: ekranet, tab-et, dritaret,
// asistenti, brava. Mbetet vetëm shiriti i gjurmëve, tani dy rreshta të hollë
// poshtë, nën çelësin e vet `GJURMET` — që nëse diçka prapë ndalet, të mos
// nisim nga e para.
//
// KUR TË MBARONI: `GJURMET = false`, dhe pastaj fshihen ky skedar,
// `diagnoza.js`, dhe rreshtat që i thërrasin te `main.jsx`, `App.jsx` dhe
// `AppLock.jsx`.
//
// ---------------------------------------------------------------------------
// TRE NUMRA
//
// Sekondat, rivizatimet, dhe çastet e rivizatimeve (milisekonda nga nisja e
// faqes). Të tretët janë të rinj dhe tregojnë PIKËRISHT kur ndalet gjithçka:
//
//   · "12 · 40 · 95" → tre rivizatime brenda 100 ms, pastaj heshtje: puna e
//     gjatë nis menjëherë pas nisjes;
//   · "12 · 40 · 3800" → mes rivizatimit të dytë dhe të tretit kaluan 3.7
//     sekonda: bllokimi ndodhi ATY, dhe e dimë se çfarë e shkaktoi rivizatimin.
//
// ---------------------------------------------------------------------------
// SI PËRDORET
//
// Vetëm ky numër ndryshohet. Asgjë tjetër.
//
//   0 → aplikacioni normal, sikur ky skedar të mos ekzistonte
//   1 → vetëm numëruesi                 (u krye — guaska: e pastër)
//   2 → `App` i plotë, pamja fikur      (u krye — efektet: të pastra)
//   3 → korniza, pa ekrane              (u krye — fajtori: te korniza)
//   4 → pa tab-e, pa FAB, pa SupportChat (u krye — nuk është cikël React-i)
//   5 → pa asnjë dritare a mbivendosje  (u krye — e sipërmja: e pastër)
//   6 → njësoj si 5, plus raporti i flamujve  (u krye — asnjë dritare e hapur)
//   7 → si 5, plus `<AppLock>`         (u krye — fajtori: brava)
//   8 → brava pa vizatuar             (u krye — faji te ajo që BËN)
//   9 → shirit gjurmësh                (u krye — fajtori: checkBiometry)
//
// Kërkimi mbaroi më 28 gusht 2026, te PROVA 9. `PROVA` rri te 0.
//
// Te shfletuesi `PROVA` nuk ka asnjë efekt në asnjë vlerë — provat vlejnë
// vetëm brenda app-it native, sepse vetëm aty shfaqet defekti.
// ============================================================================

import React from "react";
import { Capacitor } from "@capacitor/core";

export const PROVA = 0;

const ETIKETAT = {
  1: "guaska",
  2: "pas hyrjes",
  3: "korniza e plotë",
  4: "pa të poshtmen",
  5: "pa dritare",
  6: "cilat dritare janë hapur",
  7: "vetëm brava",
  8: "brava pa vizatuar",
  9: "gjurmët e bravës",
  0: "",
};

function native() {
  try {
    return Capacitor.isNativePlatform();
  } catch (_e) {
    return false;
  }
}

// Barazi e saktë — për atë që i takon VETËM njërës provë.
export function prova(n) {
  return PROVA === n && native();
}

// "Nga kjo provë e tutje" — për atë që, sapo u fik, mbetet i fikur edhe te
// provat pasuese. Pa këtë, PROVA 5 do t'i rindizte ekranet dhe tab-et që 3 e 4
// i fikën, dhe do të maste tri gjëra njëherësh.
export function provaNga(n) {
  return PROVA >= n && native();
}

// ── SA HERË, DHE KUR ───────────────────────────────────────────────────────
// Të dyja jashtë komponentit me qëllim: një numërues rivizatimesh që jeton te
// gjendja do të shkaktonte vetë rivizatimin që mat.
let rivizatime = 0;
const castet = [];
// Emrat e flamujve që janë parë të hapur qëkurse nisi faqja. I mbajmë, sepse
// një dritare mund të hapet e të mbyllet mes dy vështrimeve te ekrani — dhe
// pikërisht ajo do të ishte e para që do të na ikte.
const uPane = new Set();

// ── ÇFARË THOTË BRAVA PËR VETEN ────────────────────────────────────────────
// `AppLock` nuk është fëmijë i këtij ekrani — është motër e tij — prandaj nuk
// mund t'i kalojë dot gjendjen me props. E lë këtu, dhe ekrani e lexon kur
// rivizatohet. Vetëm raportim: asnjë sjellje nuk ndryshon prej tij.
let bravaTha = null;
export function shenoBraven(gjendja) {
  try { bravaTha = gjendja; } catch (_e) { /* asgjë */ }
}
function bravaNeFjale() {
  if (!bravaTha) return "brava: ende s'ka folur";
  const g = bravaTha;
  return "brava: mënyra=" + String(g.mode) +
         " · pajisja=" + (g.usable === null ? "?" : g.usable ? "po" : "jo") +
         " · kyçur=" + (g.locked ? "PO" : "jo") +
         " · pyet=" + (g.askFirstRun ? "PO" : "jo");
}

// ── SHIRITI I GJURMËVE ─────────────────────────────────────────────────────
// I shkruar me dorë te DOM-i, jo me React: kur fija bllokohet, React-i s'do të
// rivizatojë më, por ajo që u shkrua para bllokimit mbetet e dukshme. Kutia rri
// `pointer-events: none`, që të mos bëhet vetë shtresa që i ha prekjet — i
// njëjti kujdes si te `diagnoza.js`.
const RRESHTA_GJURME = 14;
const gjurmet = [];
let kutiaGjurmeve = null;
let trupiGjurmeve = null;

// FIKUR më 28 gusht 2026, mbrëmje. Shiriti e kreu punën: rreshti i fundit i tij
// («checkBiometry: nis») e gjeti fajtorin, dhe pastaj vërtetoi edhe ndreqjen —
// «authenticate → true». Nuk ka më çfarë të masë, dhe një kuti e zezë poshtë
// ekranit nuk është pamje që i shkon një aplikacioni familjar.
export const GJURMET = false;

export function shenoHap(teksti) {
  if (!GJURMET || !native()) return;
  try {
    const t = Math.round(performance.now());
    gjurmet.push(String(t).padStart(5) + "  " + String(teksti));
    while (gjurmet.length > RRESHTA_GJURME) gjurmet.shift();
    if (!kutiaGjurmeve) {
      kutiaGjurmeve = document.createElement("div");
      kutiaGjurmeve.style.cssText = [
        "position:fixed", "left:0", "right:0", "bottom:0", "z-index:2147483647",
        "pointer-events:none", "background:rgba(8,6,4,.94)", "color:#f2ede3",
        "font:10px/1.35 ui-monospace,Menlo,monospace",
        "padding:8px 10px calc(8px + env(safe-area-inset-bottom))",
        "max-height:40px", "overflow:hidden", "white-space:pre", "opacity:.82",
      ].join(";");
      trupiGjurmeve = document.createElement("div");
      kutiaGjurmeve.appendChild(trupiGjurmeve);
      document.body.appendChild(kutiaGjurmeve);
    }
    // Aplikacioni tani punon i plotë, prandaj shiriti tregon vetëm dy rreshtat
    // e fundit — sa duhen për të parë ku ndalet, pa e mbuluar ndërfaqen.
    trupiGjurmeve.textContent = gjurmet.slice(-2).join("\n");
  } catch (_e) { /* gjurma s'guxon ta prishë atë që ndjek */ }
}

// ── EKRANI I PROVËS ────────────────────────────────────────────────────────
// Sekondat vijnë nga `setInterval` — ato ndalen kur fija kryesore bllokohet.
// Rivizatimet numërohen sinkron — ato ndalen kur React-i pushon. Çastet i
// tregojnë të dyja në kohë. Nëse WebView-i vdes dhe faqja rindizet, të tria
// kthehen te zero — dhe kjo duket me sy, pa konsolë, pa kabllo, pa Xcode.
export function EkraniProves({ etiketa, brenda, flamujt }) {
  rivizatime++;
  const tani = [];
  if (flamujt) {
    for (const emri in flamujt) {
      if (flamujt[emri]) { tani.push(emri); uPane.add(emri); }
    }
  }
  try {
    if (castet.length < 12) castet.push(Math.round(performance.now()));
  } catch (_e) { /* asgjë */ }

  const [n, setN] = React.useState(0);
  React.useEffect(() => {
    const id = setInterval(() => setN((x) => x + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const titull = etiketa || ETIKETAT[PROVA] || "";
  return (
    <div style={{ ...(brenda ? { flex: 1, minHeight: 220 } : { minHeight: "100vh" }),
                  display: "flex", flexDirection: "column",
                  alignItems: "center", justifyContent: "center", gap: 10,
                  background: "#17140f", color: "#efe8db",
                  font: "16px/1.5 -apple-system,system-ui,sans-serif" }}>
      <div style={{ opacity: 0.7 }}>PROVA {PROVA}{titull ? " · " + titull : ""}</div>
      <div style={{ display: "flex", alignItems: "baseline", gap: 22,
                    fontVariantNumeric: "tabular-nums" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 56, fontWeight: 700 }}>{n}</div>
          <div style={{ fontSize: 11, opacity: 0.55, letterSpacing: 0.4 }}>SEKONDA</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 56, fontWeight: 700 }}>{rivizatime}</div>
          <div style={{ fontSize: 11, opacity: 0.55, letterSpacing: 0.4 }}>RIVIZATIME</div>
        </div>
      </div>
      <div style={{ fontSize: 12, opacity: 0.75, textAlign: "center", padding: "0 20px",
                    fontFamily: "ui-monospace,Menlo,monospace", wordBreak: "break-word" }}>
        {castet.join(" · ")} ms
      </div>
      {provaNga(8) && (
        <div style={{ fontSize: 12.5, textAlign: "center", padding: "0 20px",
                      color: "#f3c96b", fontFamily: "ui-monospace,Menlo,monospace",
                      wordBreak: "break-word" }}>
          {bravaNeFjale()}
        </div>
      )}
      {flamujt && (
        <div style={{ fontSize: 12.5, textAlign: "center", padding: "0 20px", lineHeight: 1.6,
                      fontFamily: "ui-monospace,Menlo,monospace", wordBreak: "break-word" }}>
          <div style={{ color: "#f3c96b" }}>
            tani: {tani.length ? tani.join(", ") : "asnjë"}
          </div>
          <div style={{ opacity: 0.7 }}>
            u panë: {uPane.size ? Array.from(uPane).join(", ") : "asnjë"}
          </div>
        </div>
      )}
      <div style={{ opacity: 0.7, textAlign: "center", padding: "0 24px" }}>
        Nëse sekondat kalojnë 60 pa u kthyer te 0,<br />kjo gjysmë është e pastër.
      </div>
    </div>
  );
}
